import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";
import { toast } from "sonner";
import { Printer, Eye, FileText } from "lucide-react";
import PosInvoicePrint from "./PosInvoicePrint";

export default function PosInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/pos/my-invoices?limit=200").then(r => setInvoices(r.data)).catch(() => toast.error("Gabim")).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-3 sm:p-4 lg:p-6">
      <div className="flex items-center gap-3 mb-4">
        <FileText size={26} className="text-[#FFD600]" />
        <h1 className="font-display text-2xl sm:text-3xl uppercase">Faturat e mia</h1>
        <span className="ml-auto text-xs text-neutral-400">Gjithsej: {invoices.length}</span>
      </div>

      {loading ? (
        <div className="text-center py-10 text-neutral-400">Duke ngarkuar...</div>
      ) : invoices.length === 0 ? (
        <div className="hg-card p-10 text-center text-neutral-500">Ende s'ka fatura.</div>
      ) : (
        <div className="hg-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-neutral-400 border-b border-[#262626]">
              <tr>
                <th className="text-left px-3 py-2">Nr. Fature</th>
                <th className="text-left px-3 py-2">Data</th>
                <th className="text-left px-3 py-2">Klienti</th>
                <th className="text-left px-3 py-2">Pagesa</th>
                <th className="text-left px-3 py-2">Statusi</th>
                <th className="text-right px-3 py-2">Totali</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {invoices.map(inv => (
                <tr key={inv.id} className="border-b border-[#262626]/50 hover:bg-[#0f0f0f]" data-testid={`inv-row-${inv.invoice_number}`}>
                  <td className="px-3 py-2 font-mono text-xs font-bold">{inv.invoice_number}</td>
                  <td className="px-3 py-2 text-xs text-neutral-400">{new Date(inv.created_at).toLocaleString("sq")}</td>
                  <td className="px-3 py-2 text-xs">{inv.client?.name || "Klient i përgjithshëm"}</td>
                  <td className="px-3 py-2">
                    <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 ${
                      inv.payment_method === "cash" ? "bg-emerald-500/15 text-emerald-400"
                      : inv.payment_method === "card" ? "bg-blue-500/15 text-blue-400"
                      : "bg-[#FFD600]/15 text-[#FFD600]"
                    }`}>
                      {inv.payment_method === "cash" ? "Kesh" : inv.payment_method === "card" ? "Kartë" : "Faturë"}
                    </span>
                  </td>
                  <td className="px-3 py-2">
                    <span className={`text-[10px] uppercase ${
                      inv.status === "returned" ? "text-red-400"
                      : inv.status === "partial_return" ? "text-orange-400"
                      : "text-emerald-400"
                    }`}>
                      {inv.status === "returned" ? "E kthyer" : inv.status === "partial_return" ? "Kthim i pjesshëm" : "Aktive"}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-right font-bold">{fmtEUR(inv.total)}</td>
                  <td className="px-3 py-2 text-right">
                    <button onClick={() => setSelected(inv)} className="p-1.5 hover:bg-[#262626]" data-testid={`inv-view-${inv.invoice_number}`}>
                      <Eye size={14} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selected && <PosInvoicePrint invoice={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
